import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import es from './es';

i18n.use(initReactI18next).init({
  resources: {
    es: {
      translations: {
        ...es,
      },
    },
  },
  fallbackLng: 'es',
  lng: 'es',
  debug: false,

  ns: ['translations'],
  defaultNS: 'translations',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
